import { ACC_GET_COMPANY_EXT_DATA } from "components/gql/gql_queries_acc";
import { logGQLError } from "data/functions";
import { useQueryWithEffect } from "../hooks/use-query-with-effect";

export function GetCompanyExtensionDataQuery() {
  const queryName = "GetCompanyStyle";
  const queryText = ACC_GET_COMPANY_EXT_DATA;
  const [refetch, variables] = useQueryWithEffect(queryText, {
    fetchPolicy: "no-cache",

    onCalled: ({ data, error }) => {
      if (error) {
        logGQLError(error, queryName);
      }
    },
  });
  return [refetch, variables];
}
